var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-district",staticStyle:{"width":"100%"}},[_c('el-cascader',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择地区","options":_vm.options}},'el-cascader',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }